module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00278.7ead836f.jpg";